export default {
  state: {
    uploadProgress:0,
    generalInfo: {},
    tempDocs: "",
    buttons:[]
  },
};
